var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ab-tag",class:[
    {
      'ab-tag_static': _vm.static,
      'ab-tag_active': _vm.isActive,
    },
    `ab-tag_${_vm.variation}`,
  ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }